import React, {Component} from "react";
import CdmLayout from "../../../../templates/cdm";
import {NavLink} from "react-router-dom";
import {confirmAlert} from "react-confirm-alert";

export class CdmPlanning extends Component {
	render() {
		return (<div className="columns">
			<div className="column no-padding-column">
				<table className="inm-table cdm">
					<thead>
					<tr>
						<th>ID</th>
						<th>Proceso</th>
						<th>Tarea</th>
						<th>Inicia</th>
						<th>Termina</th>
						<th>Responsable</th>
						<th>Estatus</th>
					</tr>
					</thead>
					<tbody>
					<tr>
						<td>
							<div className="actions">
								<NavLink to={`/cdm/planeacion/editar/1`}><i className="fa fa-edit" /></NavLink>
								<button onClick={() => this._getConfirm(1, `Identificar instituciones, programas y servicios`)}><i className="fa fa-trash-o" /></button>
							</div>
							1
						</td>
						<td><strong className="has-text-detect">DETECTAR</strong></td>
						<td><strong>Identificar instituciones, programs y servicios</strong></td>
						<td>2018-09-10</td>
						<td>2018-09-21</td>
						<td>Promotor/a</td>
						<td><span className="has-text-success">Concluido</span></td>
					</tr>
					<tr>
						<td>
							<div className="actions">
								<NavLink to={`/cdm/planeacion/editar/1`}><i className="fa fa-edit" /></NavLink>
								<button onClick={() => this._getConfirm(1, `Establecer convenios`)}><i className="fa fa-trash-o" /></button>
							</div>
							2
						</td>
						<td><strong className="has-text-coordinate">COORDINAR</strong></td>
						<td><strong>Establecer convenios</strong></td>
						<td>2018-09-21</td>
						<td>2018-10-01</td>
						<td>Coordinador/a</td>
						<td><span className="has-text-info">Iniciado</span></td>
					</tr>
					<tr>
						<td>
							<div className="actions">
								<NavLink to={`/cdm/planeacion/editar/1`}><i className="fa fa-edit" /></NavLink>
								<button onClick={() => this._getConfirm(1, `Coordinar alianzas locales`)}><i className="fa fa-trash-o" /></button>
							</div>
							3
						</td>
						<td><strong className="has-text-coordinate">COORDINAR</strong></td>
						<td><strong>Coordinar alianzas locales</strong></td>
						<td>2018-10-01</td>
						<td>2018-10-05</td>
						<td>Coordinador/a</td>
						<td><span className="has-text-info">Iniciado</span></td>
					</tr>
					<tr>
						<td>
							<div className="actions">
								<NavLink to={`/cdm/planeacion/editar/1`}><i className="fa fa-edit" /></NavLink>
								<button onClick={() => this._getConfirm(1, `Solicitar materiales`)}><i className="fa fa-trash-o" /></button>
							</div>
							4
						</td>
						<td><strong className="has-text-manage">GESTIONAR</strong></td>
						<td><strong>Solicitar materiales</strong></td>
						<td>2018-09-21</td>
						<td>2018-09-30</td>
						<td>Coordinador/a</td>
						<td><span className="has-text-danger">Sin iniciar</span></td>
					</tr>
					<tr>
						<td>
							<div className="actions">
								<NavLink to={`/cdm/planeacion/editar/1`}><i className="fa fa-edit" /></NavLink>
								<button onClick={() => this._getConfirm(1, `Identificar actores/as sociales, usuarias/os con potencial de líder e infraestructura en el municipio`)}><i className="fa fa-trash-o" /></button>
							</div>
							5
						</td>
						<td><strong className="has-text-detect">DETECTAR</strong></td>
						<td><strong>Identificar actores/as sociales, usuarias/os con potencial de líder e infraestructura en el municipio</strong></td>
						<td>2018-09-21</td>
						<td>2018-09-30</td>
						<td>Promotor/a</td>
						<td><span className="has-text-danger">Sin iniciar</span></td>
					</tr>
					<tr>
						<td>
							<div className="actions">
								<NavLink to={`/cdm/planeacion/editar/1`}><i className="fa fa-edit" /></NavLink>
								<button onClick={() => this._getConfirm(1, `Administrar materiales`)}><i className="fa fa-trash-o" /></button>
							</div>
							6
						</td>
						<td><strong className="has-text-manage">GESTIONAR</strong></td>
						<td><strong>Administrar materiales</strong></td>
						<td>2018-09-21</td>
						<td>2018-09-30</td>
						<td>Coordinador/a</td>
						<td><span className="has-text-danger">Sin iniciar</span></td>
					</tr>
					<tr>
						<td>
							<div className="actions">
								<NavLink to={`/cdm/planeacion/editar/1`}><i className="fa fa-edit" /></NavLink>
								<button onClick={() => this._getConfirm(1, `Incluir a la comunidad`)}><i className="fa fa-trash-o" /></button>
							</div>
							7
						</td>
						<td><strong className="has-text-integrate">INTEGRAR</strong></td>
						<td><strong>Incluir a la comunidad</strong></td>
						<td>2018-09-21</td>
						<td>2018-09-30</td>
						<td>Promotor/a</td>
						<td><span className="has-text-danger">Sin iniciar</span></td>
					</tr>

					</tbody>
				</table>
			</div>
		</div>);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar la actividad ${name}?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => console.log('ELIMINAR ITEM', id)
		})
	}
}

export default CdmLayout(CdmPlanning, {
	title: 'Planeación',
	subnav: {
		icon: 'fa-calendar-check-o',
		name: 'Planear',
		actions: [
		]
	},
	stateNav: true,
	progress: true
});


// WEBPACK FOOTER //
// ./src/cdm-frontend/pages/support/planning/index.jsx